import {makeStyles} from '@material-ui/core';
import {useDispatch, useSelector} from "react-redux";
import {moveNextPage, updateUserMetrics} from "../../../store/actions/creator/creatorExperienceBuilder";
import clsx from 'clsx';
import UtilService from '../../../helper/service';
import Tooltip from '@material-ui/core/Tooltip';
import {Theme, withStyles} from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import {useCallback} from "react";

const ActiveTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: '#212D40',
    fontSize: 11,
    fontFamily: 'roboto-bold'
  },
}))(Tooltip);

const InactiveTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: '#D9D9D9',
    fontSize: 11,
    fontFamily: 'roboto-bold'
  },
}))(Tooltip);

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 850px)': {
      width: 200
    },
  },
  inactiveNormal: {
    width: 35,
    height: 35,
    borderRadius: 18,
    border: '4px solid #D9D9D9',
    background: '#F0F0F0',
    marginTop: 18,
  },
  inactiveSmall: {
    width: 17,
    height: 17,
    borderRadius: 18,
    border: '4px solid #D9D9D9',
    background: '#F0F0F0',
    zIndex: -1,
  },
  activeNormal: {
    width: 90,
    height: 90,
    borderRadius: 45,
    border: '4px solid #017AEF',
    background: '#F0F0F0',
    marginTop: 50,
  },
  activeSmall: {
    width: 35,
    height: 35,
    borderRadius: 18,
    border: '4px solid #017AEF',
    background: '#F0F0F0',
  },
  activeFillNormal: {
    width: 90,
    height: 90,
    borderRadius: 45,
    background: '#017AEF',
    zIndex: 100,
    marginTop: 50,
  },
  completedNormal: {
    width: 35,
    height: 35,
    borderRadius: 18,
    border: '4px solid #D9D9D9',
    background: '#D9D9D9',
    zIndex: 10,
    marginTop: 18,
    '&:hover': {
      cursor: 'pointer',
      borderColor: "#017AEF"
    }
  },
  completedSmall: {
    zIndex: 10,
    width: 17,
    height: 17,
    borderRadius: 18,
    border: '4px solid #D9D9D9',
    background: '#D9D9D9',
    
    '&:hover': {
      cursor: 'pointer',
      borderColor: "#017AEF"
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    }
  },
  mt0:{
    marginTop: 1,
    marginBottom: 30
  },
  mb35: {
    marginBottom: 35
  }
})
);

function CreatorSidebar() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { page, userMetrics, globalSaveSetting } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { path, modLastActivePage, asyncLastActivePage } = userMetrics;
  const { totalExperienceCount } = useSelector((state: any) => state.experience);

  const onWheel = useCallback((e: any) => {
    let targetPage = 0;
    if (e.deltaY < 0) { // scroll up
      if (page === 4 && globalSaveSetting) {
        targetPage = page - (page !== 0 ? 2 : 0);
      } else {
        targetPage = page - (page !== 0 ? 1 : 0);
      }
    } else { // scroll down
      if (page === 2 && globalSaveSetting) {
        targetPage = page + (page < UtilService.detectSidebarConfig(userMetrics, globalSaveSetting).length ? 2 : 0);
      } else {
        targetPage = page + (page < UtilService.detectSidebarConfig(userMetrics, globalSaveSetting).length ? 1 : 0);
      }
    }
    onMovePage((userMetrics.braintrust && (targetPage === 1 || targetPage === 2)) ? 0 : targetPage)
  }, [page, globalSaveSetting, userMetrics.braintrust]);

  const onMovePage = useCallback((nextPage: number) => {
    if (
      UtilService.detectSidebarConfig(userMetrics, globalSaveSetting).length - 1 >= nextPage
      && (path === 1 ? asyncLastActivePage : modLastActivePage) >= nextPage
    ) {
      dispatch(moveNextPage((userMetrics.braintrust && (nextPage === 1 || nextPage === 2)) ? 0 : nextPage))
    }
  }, [userMetrics, globalSaveSetting, modLastActivePage, asyncLastActivePage, path]);

  const checkFirstTimeBuilder = () => {
    return totalExperienceCount !== null && totalExperienceCount === 0
  };

  const checkAndGoPage = (pageId: number) => {
    checkFirstTimeBuilder() && dispatch(updateUserMetrics('myOwn', false)); // go Great Choice page
    dispatch(updateUserMetrics('otherSubmitted', false));
    dispatch(updateUserMetrics('item', ''));
    dispatch(updateUserMetrics('content', ''));
    onMovePage(pageId);
  };

  const goFirstChoicePage = () => {
    dispatch(updateUserMetrics('trialFirstStep', true));
    dispatch(updateUserMetrics('myOwn', false));
    dispatch(updateUserMetrics('otherSubmitted', false));
    dispatch(updateUserMetrics('item', ''));
    dispatch(updateUserMetrics('content', ''));
    dispatch(updateUserMetrics('path', 0));
    dispatch(moveNextPage(0));
  };

  return (
    <div className={classes.root} onWheel={e => onWheel(e)}>
      <div className='builder-sideBar-container'>

        <div className={clsx(classes.content, 'mt-65')} onClick={() => checkFirstTimeBuilder() && goFirstChoicePage()}>
          {page !== 0 && <img src={'/assets/icons/onboarding/progressbar/builder-inactive-first-img.svg'} alt="{img}" style={{ marginTop: 18 }}/>}
          {page === 0 && <img src={'/assets/icons/onboarding/progressbar/builder-active-first-img.svg'} alt="{img}" style={{ marginTop: 18 }}/>}
        </div>
        
        {
          UtilService.detectSidebarConfig(userMetrics, globalSaveSetting).map((item: any, index: number) =>
            <div className={classes.content} key={index} onClick={()=> index === 0 ? checkAndGoPage(item.pageId) : onMovePage(item.pageId)}>

              {page !== item.pageId && item.inactive && <img src={'/assets/icons/onboarding/progressbar/' + item.inactive} alt="{img}" style={{ marginTop: index !== 0 ? 18 : 0 }}/>}
              {page === item.pageId && item.active && <img src={'/assets/icons/onboarding/progressbar/' + item.active} alt="{img}" style={{ marginTop: index !== 0 ? 40 : 0 }}/>}

              {page !== item.pageId && !item.inactive && (
                page > item.pageId ? (
                  <ActiveTooltip title={item.hoverName} placement="right" TransitionComponent={Fade} TransitionProps={{ timeout: 1000 }}>
                    <div className={classes.completedNormal} />
                  </ActiveTooltip>
                ) : (
                  <InactiveTooltip title={item.hoverName} placement="right" TransitionComponent={Fade} TransitionProps={{ timeout: 1000 }}>
                    <div className={classes.inactiveNormal} />
                  </InactiveTooltip>
                )
              )} 
              {page === item.pageId && !item.active && <div className={clsx((UtilService.builderSidebar(userMetrics, item.stepKey[0]) ? classes.activeFillNormal : classes.activeNormal), item.stepKey.length === 1 && classes.mb35)} />}

              {item.stepKey.length > 1 && <div className={page !== item.pageId ? (page > item.pageId ? classes.completedSmall : classes.inactiveSmall) : clsx((UtilService.builderSidebar(userMetrics, item.stepKey[0]) ? classes.activeSmall : classes.inactiveNormal), classes.mt0)} />}

            </div>
          )
        }
      </div>

    </div>

  )

}

export default CreatorSidebar;